import instance, { ADMIN_PREFIX } from 'services/api';
import {
  SpecialtyDetail,
  SpecialtyInput,
  SpecialtyListItem,
  SpecialtyListQuery
} from 'types/api/specialties';

const DEFAULT_LIMIT = 999;

/**
 * GET /api/v2/admin/content/specialties — PaginatedResponse envelope on
 * the BE. The legacy GQL was unbounded + client-side paginated; FE
 * consumers expect a bare list so we flatten `data` here and request
 * `limit: 999` by default.
 */
export const fetchSpecialties = async (
  query: SpecialtyListQuery = {}
): Promise<SpecialtyListItem[]> => {
  const params: Record<string, string | number | boolean> = {
    page: 1,
    limit: query.limit ?? DEFAULT_LIMIT
  };

  if (query.lang) params.lang = query.lang;
  if (query.symptom !== undefined) params.symptom = query.symptom;
  if (query.name) params.name = query.name;

  const res = await instance.get<{ data: SpecialtyListItem[] }>(
    `${ADMIN_PREFIX}/content/specialties`,
    { params }
  );

  return res.data.data ?? [];
};

export const fetchSpecialtyById = async (
  id: string | number
): Promise<SpecialtyDetail> => {
  const res = await instance.get<SpecialtyDetail>(
    `${ADMIN_PREFIX}/content/specialties/${id}`
  );

  return res.data;
};

export const createSpecialty = (input: SpecialtyInput) =>
  instance.post<SpecialtyDetail>(`${ADMIN_PREFIX}/content/specialties`, input);

export const updateSpecialty = (id: string | number, input: SpecialtyInput) =>
  instance.put<SpecialtyDetail>(
    `${ADMIN_PREFIX}/content/specialties/${id}`,
    input
  );

export const deleteSpecialty = (id: string | number) =>
  instance.delete(`${ADMIN_PREFIX}/content/specialties/${id}`);
